import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import './Header.css';

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header__content">
          <Link to="/" className="header__logo">
            <img src="/Furudio-logo.svg" alt="Furudio" className="header__logo-image" />
            <span className="header__logo-text">Furudio</span>
          </Link>

          <nav className={`header__nav ${mobileMenuOpen ? 'header__nav--open' : ''}`}>
            <Link to="#features" onClick={() => scrollToSection('features')} className="header__nav-link">
              How It Works
            </Link>
            <Link to="#who-is-it-for" onClick={() => scrollToSection('who-is-it-for')} className="header__nav-link">
              Who It's For
            </Link>
            <Link to="#about" onClick={() => scrollToSection('about')} className="header__nav-link">
              About
            </Link>
          </nav>

          <div className="header__actions">
            <button
              className="header__cta-button"
              onClick={() => scrollToSection('contact')}
            >
              Book a strategy conversation
            </button>
            <button
              className="header__menu-toggle"
              onClick={toggleMobileMenu}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
